import { statusCellRenderer, actionCellRenderer, optionsCellRenderer, creationDateCellRenderer, statusSortingFn, } from './cell-renderers';
// Create stable column definitions
export const createStaticColumns = (translations) => [
    {
        header: translations?.locales,
        accessorKey: 'locale',
    },
    {
        header: translations?.studyVersion,
        accessorKey: 'buildVersion',
        enableSorting: false,
    },
    {
        header: translations?.options,
        accessorKey: 'options',
        cell: optionsCellRenderer,
        enableSorting: false,
    },
    {
        header: translations?.createdBy,
        accessorKey: 'user',
        enableSorting: false,
    },
    {
        header: translations?.creationDate,
        accessorKey: 'createdAt',
        cell: creationDateCellRenderer,
    },
];
export const createDynamicColumns = (translations) => [
    {
        header: translations?.status,
        accessorKey: 'status',
        cell: statusCellRenderer,
        sortingFn: statusSortingFn,
    },
    {
        header: ' ',
        accessorKey: 'action',
        enableSorting: false,
        cell: actionCellRenderer,
    },
];
